import { useState } from 'react'
import { Container, Row, Col, Card, Badge } from 'react-bootstrap'
import {
  FaStethoscope, FaDumbbell, FaPills, FaGlasses, FaSchool,
  FaCut, FaPaw, FaCar, FaMusic, FaSpa, FaGavel, FaUmbrellaBeach,
  FaFistRaised, FaTooth, FaMicroscope
} from 'react-icons/fa'

const CATEGORIAS = [
  {
    id: 'oftalmologia',
    label: 'Clínica Oftalmológica',
    icon: <FaStethoscope />,
    items: [
      {
        nome: 'Tosi Instituto Oftalmológico',
        endereco: 'R. Antônio Xavier de Mendonça, 2-49 — Vila Universitária',
        telefone: '3224-2115',
        desconto: 'Desconto de R$100,00 na consulta',
      },
    ],
  },
  {
    id: 'fisioterapia',
    label: 'Fisioterapia',
    icon: <FaStethoscope />,
    items: [
      {
        nome: 'Dra. Elisa Rocha Caminaga',
        endereco: 'Rua Araujo Leite, 2-25 — Centro',
        telefone: '99814-1583',
        desconto: 'Desconto de 50%',
      },
    ],
  },
  {
    id: 'laboratorio',
    label: 'Laboratórios e Clínicas',
    icon: <FaMicroscope />,
    items: [
      {
        nome: 'Magna Diagnóstico por Imagem',
        endereco: 'Rua Monsenhor Claro, 7-77',
        telefone: '(14) 3235-2500',
        desconto: 'Desconto conforme tabela da clínica em: Mamografia, Ultrasson, Tomografia, Raio X, Desintometria e Ressonância Magnética',
      },
      {
        nome: 'Dr. Álvaro Ernesto Bien',
        endereco: 'Rua Saint Martin, 21-85',
        telefone: '3223-4010',
        desconto: 'Desconto de 50% em consultas',
      },
      {
        nome: 'Biolab — Laboratório de Análise Clínicos',
        endereco: 'R. Gustavo Maciel, 16-40 / R. Antonio Alves, 25-75',
        telefone: '3214-3432 / 3262-2078',
        desconto: 'Descontos de até 20% em exames',
      },
      {
        nome: 'Pró Clínica',
        endereco: 'R. Manoel Bento Cruz, 1-32',
        telefone: '3245-4447 / 3245-4465',
        desconto: 'Desconto de 10% em consultas e procedimentos conforme tabela da clínica',
      },
    ],
  },
  {
    id: 'odontologia',
    label: 'Plano Odontológico',
    icon: <FaTooth />,
    items: [
      {
        nome: 'Plano Odontológico',
        endereco: '',
        telefone: '',
        desconto: 'Novo benefício conquistado pelo sindicato! Plano odontológico totalmente gratuito para os associados e seus dependentes.',
        destaque: true,
      },
    ],
  },
  {
    id: 'academia',
    label: 'Academia de Musculação',
    icon: <FaDumbbell />,
    items: [
      {
        nome: 'Guaraná Clube',
        endereco: 'R. Hildebrando de Carvalho, 9-46 — Bela Vista',
        telefone: '99902-2448',
        desconto: 'Desconto de 10% nas mensalidades',
      },
    ],
  },
  {
    id: 'farmacia',
    label: 'Farmácias',
    icon: <FaPills />,
    items: [
      {
        nome: 'Farmácia Específica',
        endereco: 'R. Gustavo Maciel, 14-65 / R. Antonio Alves, 26-09',
        telefone: '3104-3355',
        desconto: 'Desconto de 10% no pagamento à vista',
      },
      {
        nome: 'Pharma Gold',
        endereco: 'R. Wenceslau Braz, 5-59 — Vila Falcão',
        telefone: '',
        desconto: 'Desconto de 12% em todos os produtos, parcelamento no cartão e entrega em toda a cidade de Bauru',
      },
    ],
  },
  {
    id: 'otica',
    label: 'Ótica',
    icon: <FaGlasses />,
    items: [
      {
        nome: 'Óptica Imagem',
        endereco: 'R. Treze de Maio, 13-33',
        telefone: '3222-4384',
        desconto: '20% de desconto no pagamento à vista / 10% de desconto no pagamento a prazo',
      },
    ],
  },
  {
    id: 'escola',
    label: 'Escolas Particulares',
    icon: <FaSchool />,
    items: [
      {
        nome: 'Focus Idiomas',
        endereco: 'R. Cristiano Pagani, 5-38 — Jd. Ouro Verde (próx. portão 07 do Camelias)',
        telefone: '3879-6793 / 3016-6570',
        desconto: 'Desconto de 50% nas mensalidades — isenção de taxa de matrícula',
      },
      {
        nome: 'Colégio Dom Bosco',
        endereco: 'R. Carlos Gomes, 4-27',
        telefone: '3212-1686',
        desconto: 'Desconto de até 50% no valor das mensalidades (Educação Infantil, Ensino Fundamental e Médio)',
      },
    ],
  },
  {
    id: 'podologia',
    label: 'Podólogas',
    icon: <FaSpa />,
    items: [
      {
        nome: 'Vera Lucia',
        endereco: 'R. Boa Esperança, 2-44 — Vila Seabra (próx. Sind. Condutores)',
        telefone: '3016-7461 / 99772-1724',
        desconto: 'Desconto de 20% nos serviços prestados',
      },
      {
        nome: 'Sara Zeola',
        endereco: 'R. Dionísio de Aguiar, 4-78 — Jardim Auri Verde',
        telefone: '(14) 99845-5356',
        desconto: 'Procedimentos tradicionais 20% · Orestes Corretivas 15% · Unhas Infeccionadas 20% · Laser/Jato de Plasma (Micose, Verrugas, Olho de Peixe e Calos) 15%',
      },
    ],
  },
  {
    id: 'veterinaria',
    label: 'Clínica Veterinária',
    icon: <FaPaw />,
    items: [
      {
        nome: 'Clínica Veterinária Animalys',
        endereco: 'Rua dos Andradas, 4-3',
        telefone: '3226-4893',
        desconto: 'Desconto de 20% nas consultas',
      },
    ],
  },
  {
    id: 'oficina',
    label: 'Oficinas e Troca de Óleo',
    icon: <FaCar />,
    items: [
      {
        nome: 'Confilub Troca de Óleo',
        endereco: 'Av. Moussa Nakhl Tobias, 3-80 · R. Antonio Gobete, 10-45 (Jd. Contorno) · R. Iracema Cândido Posca, 1-70 (Dist. Industrial) · V. José da Silva Martha, 24-10 · R. Profº José Nogueira de Abreu, 3-92 — Agudos-SP',
        telefone: '',
        desconto: 'Desconto de 10% em todos os serviços (pagamento à vista ou no cartão) em todas as lojas da rede Confilub',
      },
    ],
  },
  {
    id: 'som',
    label: 'Som e Acessórios',
    icon: <FaMusic />,
    items: [
      {
        nome: 'Equalize Som e Assessórios',
        endereco: 'Rua Araujo Leite, 2-16 — próx. Av. Nuno de Assis',
        telefone: '',
        desconto: '5% de desconto em todas as compras + 5% de desconto em todos os serviços',
      },
    ],
  },
  {
    id: 'cabeleireiro',
    label: 'Salão de Cabeleireiros',
    icon: <FaCut />,
    items: [
      {
        nome: 'Salão do Léo — Corte Masculino',
        endereco: 'Rua Presidente Kennedy, 7-7 — Esquina com Rua Antonio Alves',
        telefone: '',
        desconto: 'Convênio gratuito para sócios e seus dependentes',
      },
      {
        nome: 'Salão do Léo — Corte Feminino',
        endereco: 'Rua Ezequiel Ramos, 1-39 — Centro (em frente ao posto de gasolina, próximo ao INSS)',
        telefone: '',
        desconto: 'Convênio gratuito para sócios e seus dependentes',
      },
    ],
  },
  {
    id: 'juridico',
    label: 'Atendimento Jurídico',
    icon: <FaGavel />,
    items: [
      {
        nome: 'Dr. Jorge Moura & Dr. Samuel Bispo',
        endereco: 'Sede do Sindicato — Rua Araujo Leite, 2-25',
        telefone: '',
        desconto: 'Segunda a Sexta — das 9h00 às 12h00 e das 14h00 às 17h00, com hora marcada. Serviço gratuito para associados.',
        destaque: true,
      },
    ],
  },
  {
    id: 'lazer',
    label: 'Área de Lazer',
    icon: <FaUmbrellaBeach />,
    items: [
      {
        nome: 'Área de Lazer Vila São Paulo',
        endereco: 'Bauru — SP',
        telefone: '',
        desconto: 'Acesso exclusivo para associados e dependentes',
      },
      {
        nome: 'Rancho Recanto dos Paturis',
        endereco: '',
        telefone: '',
        desconto: 'Acomodações para 8 pessoas · Piscina · Churrasqueira · Pier para pesca',
      },
      {
        nome: 'Colônia de Férias FEM-CUT',
        endereco: 'Unidade Caraguatatuba-SP / Unidade Itanhaém-SP',
        telefone: '',
        desconto: 'Convênio com o Metal Bauru para sócios e dependentes',
      },
    ],
  },
  {
    id: 'artesmarciais',
    label: 'Artes Marciais',
    icon: <FaFistRaised />,
    items: [
      {
        nome: 'Judô e Jiu-Jitsu — Associação de Artes Marciais Caminaga',
        endereco: 'Sede do Sindicato — Rua Araujo Leite, 2-25',
        telefone: '',
        desconto: 'Aulas gratuitas para sócios e seus dependentes. Venha fazer uma aula experimental sem compromisso!',
        destaque: true,
      },
    ],
  },
]

function BeneficioCard({ item, categoriaLabel }) {
  return (
    <Card className="beneficio-card h-100">
      <Card.Body>
        <div className="beneficio-desconto">{item.desconto}</div>
        <Card.Title className="beneficio-nome">{item.nome}</Card.Title>
        {item.endereco && (
          <p className="beneficio-info">
            <span className="beneficio-info-label">Endereço:</span> {item.endereco}
          </p>
        )}
        {item.telefone && (
          <p className="beneficio-info">
            <span className="beneficio-info-label">Telefone:</span> {item.telefone}
          </p>
        )}
      </Card.Body>
      <Card.Footer className="beneficio-footer">
        <Badge className="beneficio-badge">{categoriaLabel}</Badge>
      </Card.Footer>
    </Card>
  )
}

function Beneficios() {
  const [filtro, setFiltro] = useState('todos')

  const categoriasFiltradas = filtro === 'todos'
    ? CATEGORIAS
    : CATEGORIAS.filter(c => c.id === filtro)

  return (
    <Container>
      <div style={{ marginTop: '2.5rem', marginBottom: '3rem' }}>
        <Row className="mb-4">
          <Col xs={12}>
            <h2 className="section-title">Benefícios</h2>
            <p className="text-muted">
              Descontos e convênios exclusivos para associados e seus dependentes.
              Apresente sua carteirinha do sindicato para utilizar os benefícios.
            </p>
          </Col>
        </Row>

        {/* Filtro por categoria */}
        <Row className="mb-4">
          <Col xs={12}>
            <div className="beneficio-filtros">
              <button
                className={`beneficio-filtro-btn${filtro === 'todos' ? ' ativo' : ''}`}
                onClick={() => setFiltro('todos')}
              >
                Todos
              </button>
              {CATEGORIAS.map(cat => (
                <button
                  key={cat.id}
                  className={`beneficio-filtro-btn${filtro === cat.id ? ' ativo' : ''}`}
                  onClick={() => setFiltro(cat.id)}
                >
                  {cat.icon} <span>{cat.label}</span>
                </button>
              ))}
            </div>
          </Col>
        </Row>

        {/* Cards agrupados por categoria */}
        {categoriasFiltradas.map(categoria => (
          <div key={categoria.id} className="mb-5">
            <h5 className="beneficio-categoria-titulo">
              {categoria.icon} {categoria.label}
            </h5>
            <Row className="g-3">
              {categoria.items.map((item, idx) => (
                <Col key={idx} xs={12} sm={6} lg={4}>
                  <BeneficioCard item={item} categoriaLabel={categoria.label} />
                </Col>
              ))}
            </Row>
          </div>
        ))}
      </div>
    </Container>
  )
}

export default Beneficios